import { render, staticRenderFns } from "./SelecionarCar.vue?vue&type=template&id=b31ad148&scoped=true&lang=pug"
import script from "./SelecionarCar.vue?vue&type=script&lang=js"
export * from "./SelecionarCar.vue?vue&type=script&lang=js"
import style0 from "./SelecionarCar.vue?vue&type=style&index=0&id=b31ad148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31ad148",
  null
  
)

export default component.exports